import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ENVIRONMENT } from '../environment/environment.token';

/**
 * Redireciona para /login quando o usuário não está autenticado.
 */
export const authGuard: CanActivateFn = (_route, _state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const environment = inject(ENVIRONMENT);

  if (!environment.requireAuth) {
    return true;
  }

  if (auth.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login']);
};

export const authChildGuard: CanActivateChildFn = (route, state) => authGuard(route, state);
